import {Component, Input} from "@angular/core";
import {ClipboardService} from 'ngx-clipboard';

@Component({
  selector: 'copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss']
})
export class CopyToClipboardComponent {

  constructor(private readonly clipboardService: ClipboardService) {
  }

  @Input() toolTipMessageBefore: string = 'Copy to clipboard';

  @Input() toolTipMessageAfter: string = 'Copied';

  @Input() data: string;

  public isCopied = false;

  public get getData(): string {
    return this.data || '';
  }

  public toggleTooltip(event: MouseEvent, isCopied: boolean): void {
    event.stopPropagation();
    this.isCopied = isCopied;
  }

  public copyToClipboard(event: MouseEvent): void {
    this.clipboardService.copy(this.getData);
    this.toggleTooltip(event, true);
  }
}
